import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import { AiFillCaretRight, AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import ContainsArea from "../../Components/ContainsArea/ContainsArea";

const CommercialMotorComprehensiveInsurance = () => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-home-loan-banner.png";
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/CommercialMotorComprehensiveInsurance.png";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accountContent = "Light trucks, trailers, Agric and forestry vehicles excluding those used for hire and reward such as taxis, PSV buses or Yango";

  
  const [openIndex, setOpenIndex] = useState(null);


  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
       <section className="CommercialMotorInsuranceSection">
        <Breadcrumb Heading="Commercial Motor Comprehensive Insurance" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
       </section>

       <SavePlusAccountComponent heading="Commercial Motor Comprehensive Insurance" subHeading="Know About" btnTxt="Apply Now" content={accountContent} img={img1} logo={true} />
       {/* <ContainsArea /> */}

        <section>
            <div className="container">
            <div className="row">
                <div className="col-xl-12 justify-content-center">
                <div className="faq-style1__content">
                   
                <ul className="accordion-box custom-accordion-box custom-accordion-box-mt mt-2" style={{paddingBottom: "50px"}}>
                    {/* Eligibility */}
                    <li className={`accordion block ${openIndex === 0 ? "active-block" : ""}`}>
                        <div
                        className={`acc-btn ${openIndex === 0 ? "active" : ""}`}
                        style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                        onClick={() => handleToggle(0)}
                        >
                        <div className="icon-outer text-white">
                            {openIndex === 0 ? <AiOutlineArrowRight /> : <AiOutlineArrowRight />}
                        </div>
                        <h3 className="text-white">Eligibility</h3>
                        </div>
                        {openIndex === 0 && (
                        <div className={`acc-content ${openIndex === 0 ? "current" : ""} px-5`}>
                            <ul>
                            <li>
                                <AiFillCaretRight className="me-1 accordion-icon" /> <p>Banking Customers (both personal and corporate)</p>
                            </li>
                            </ul>
                        </div>
                        )}
                    </li>

                    {/* Basis of Cover */}
                    <li className={`accordion block ${openIndex === 1 ? "active-block" : ""}`}>
                        <div
                        className={`acc-btn ${openIndex === 1 ? "active" : ""}`}
                        style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                        onClick={() => handleToggle(1)}
                        >
                        <div className="icon-outer text-white">
                            {openIndex === 1 ? <AiOutlineArrowRight /> : <AiOutlineArrowRight />}
                        </div>
                        <h3 className="text-white">Basis of Cover</h3>
                        </div>
                        {openIndex === 1 && (
                        <div className={`acc-content ${openIndex === 1 ? "current" : ""} px-5`}>
                            <ul className="first-list">
                                <li><AiFillCaretRight className="me-1 accordion-icon" /><p>
                                Accidental loss of damage to the insured vehicle and its accessories whilst thereon, belonging to the insured or for which they are responsible to insure. Cover also includes legal liability to third parties for bodily injury, accidental death and property damage. 
                                    </p>
                                </li>
                                <h5 className="pt-4 pb-3">COMBINED THIRD-PARTY LIABILITY COVER</h5>

                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                        <th>Insurer</th>
                                        <th>Kwacha (ZMW)</th>
                                        <th>Dollar (USD)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr><td>Nico Insurance</td><td>600,000.00</td><td>50,000.00</td></tr>
                                        <tr><td>Hollard Insurance</td><td>600,000.00</td><td>50,000.00</td></tr>
                                        <tr><td>Professional Insurance</td><td>600,000.00</td><td>50,000.00</td></tr>
                                        <tr><td>Madison</td><td>600,000.00</td><td>50,000.00</td></tr>
                                        <tr><td>ZSIC</td><td>300,000.00</td><td>25,000.00</td></tr>
                                        <tr><td>Indigo</td><td>150,000.00</td><td>15,000.00</td></tr>
                                    </tbody>
                                </table>

                                <h5 className="pt-4 pb-3">Additional benefits- Applicable to all Insurers</h5>

                                <ul className="submenu-level-2">
                                    <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Personal effects – K10,000.00 or USD 1,000.00 per event</p></li>
                                    <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Nil excess on windscreen/auto glass</p></li>
                                    <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Emergency repairs – K15,000.00 or USD1,000.00 subject to prior inspection by the insurers</p></li>
                                    <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Foreign Use (Own damage only) – Free cover for all COMESA and SADC countries for the first 30 days</p></li>
                                    <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Towing charges – K 1,000 within town and K3,000 out of town arrangements. All amounts above these limits to be approved by the insurers</p></li>
                                    <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Medical expenses for injuries to the driver – K5,000.00 or USD500.00 per event</p></li>
                                    <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Hire of alternative vehicle for the insured and Third Parties – K1,500.00 or USD 100 per day max 21/30 days – Subject to submission of claim documents with 5 days excess</p></li>
                                    <li><AiFillCaretRight className="me-1 accordion-icon" /><p>10% Minimum K1,000.00 or USD 100 each and every claim including theft claims</p></li>
                                    <li><AiFillCaretRight className="me-1 accordion-icon" /><p>Double excess for under aged and inexperienced drivers who are below 21 years and have less than 2 years of driving experience</p></li>
                                </ul>

                            </ul>
                        </div>
                        )}
                    </li>

                    <li className={`accordion block ${openIndex === 2 ? "active-block" : ""}`}>
                        <div
                        className={`acc-btn ${openIndex === 2 ? "active" : ""}`}
                        style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                        onClick={() => handleToggle(2)}
                        >
                        <div className="icon-outer text-white">
                            {openIndex === 2 ? <AiOutlineArrowRight /> : <AiOutlineArrowRight />}
                        </div>
                        <h3 className="text-white">Requirements</h3>
                        </div>
                        {openIndex === 2 && (
                        <div className={`acc-content ${openIndex === 2 ? "current" : ""} px-5`}>
                            <ul>
                            <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>Photos of the vehicle(s) to be insured</p></li>
                            <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>Vehicle registration number</p></li>
                            <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>Correct replacement value</p></li>
                            <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>Schedule of the vehicle(s) to be covered with the above information if two or more vehicles are to be covered</p></li>
                            </ul>
                        </div>
                        )}
                    </li>

                    <li className={`accordion block ${openIndex === 3 ? "active-block" : ""}`}>
                        <div
                        className={`acc-btn ${openIndex === 3 ? "active" : ""}`}
                        style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                        onClick={() => handleToggle(3)}
                        >
                        <div className="icon-outer text-white">
                            {openIndex === 3 ? <AiOutlineArrowRight /> : <AiOutlineArrowRight />}
                        </div>
                        <h3 className="text-white">Settlement</h3>
                        </div>
                        {openIndex === 3 && (
                        <div className={`acc-content ${openIndex === 3 ? "current" : ""} px-5`}>
                            <ul>
                            <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>Replacement value for showroom vehicles within 2 years of the date of manufacture and market value for all vehicle beyond 2 years</p></li>
                            </ul>
                        </div>
                        )}
                    </li>


                    <li className={`accordion block ${openIndex === 4 ? "active-block" : ""}`}>
                        <div
                        className={`acc-btn ${openIndex === 4 ? "active" : ""}`}
                        style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                        onClick={() => handleToggle(4)}
                        >
                        <div className="icon-outer text-white">
                            {openIndex === 4 ? <AiOutlineArrowRight /> : <AiOutlineArrowRight />}
                        </div>
                        <h3 className="text-white">Notable Exclusion Among Others</h3>
                        </div>
                        {openIndex === 4 && (
                        <div className={`acc-content ${openIndex === 4 ? "current" : ""} px-5`}>
                            <ul>
                                <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>Wear and tear</p></li>
                                <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>Mechanical, electronic or electrical breakdown, failure or breakage</p></li>
                                <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>Damage to the tyres by application of brakes; or by road punctures, cuts or bursts; or as a result of inequalities of the road or other surface or to impact with such inequalities unless damage to tyres is accompanied by damage to other parts of the vehicle as a result of an accident</p></li>
                                <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>Willful acts</p></li>
                                <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>Unlicensed drivers</p></li>
                                <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>Consequential loss</p></li>
                                <li><AiFillCaretRight className="me-1 accordion-icon" /> <p>Damage to springs/shock absorbers due to inequalities of the road or other surface or to impact with such inequalities</p></li>
                            </ul>
                        </div>
                        )}
                    </li>

                    
                    <li className={`accordion block ${openIndex === 5 ? "active-block" : ""}`}>
                                                    <div className={`acc-btn  ${openIndex === 5 ? "active" : ""}`} 
                                                         style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                                                         onClick={() => handleToggle(5)}>
                                                            <div className="icon-outer text-white">
                                                                {openIndex === 5 ? <AiOutlineArrowRight /> : <AiOutlineArrowRight />}
                                                            </div>
                                                            <h3 className="text-white">How to Apply</h3>
                                                    </div>
                                                    {openIndex === 5 && (
                                                        <div className={`acc-content ${openIndex === 5 ? "current" : ""} px-5`}>
                                                            <p>
                                                                <AiFillCaretRight className="me-1 accordion-icon" />
                                                                <span className="mt-1">
                                                                    To apply now, email <a href="mailto:bancassurance@izb.co.zm">bancassurance@izb.co.zm</a> or call <a href="tel:8002">8002</a>
                                                                </span>
                                                            </p>
                                                        </div>
                                                    )}
                    </li>

                </ul>

                </div>
                </div>
            </div>
            </div>
        </section>

       <AllAcountsSection />
    </>
  );
};

export default CommercialMotorComprehensiveInsurance;